<template>
<div v-if="auth.token && auth.login">
  <div class="bg-white rounded border p-3">
      <div class="col-md-12 border-md-left">
        <div class="ow py-3">
          <div class="col-md-12 m-auto">
            <div class="text-center">
              <span class="h3">سطح فعلی شما : </span><span class="h3 color-blue levelPerson text-success">کاربر {{ level }}</span>
            </div>
            <p class="text-center" v-if="level != 'الماس'">تنها <span class="untilNextLevel">{{ convertToPersian(String(nextScore)) }}</span> امتیاز تا سطح بعدی</p>
          </div>
          <div class="prcol-md-12">
            <div class="flex-wrapper">
              <div class="single-chart m-auto" id="chart">
                <svg viewBox="0 0 36 36" class="circular-chart blue">
                  <path
                    class="circle-bg"
                    d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
                  ></path>
                  <path
                    class="circle"
                    stroke-dasharray="61,100"
                    d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
                  ></path>
                </svg>
                <div class="prd-flex prflex-column pralign-items percentage" v-if="auth.profile">
                  <span class="thisLevelPerson " >{{ convertToPersian(String(auth.profile.score)) }}</span><span>از <span class="thisLevelPersonLimit ">{{ convertToPersian(String(inScore)) }}</span></span>
                </div>
                <div class="prtext-center" v-if="level != 'الماس'">
                  <span>سطح بعدی : </span><span class="h3 prcolor-blue nextLevelPerson">{{ convertToPersian(String(nextLevel)) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="ow py-3">
          <div class="col-md-12">
            <div>
              <span class="h3">۱۵ امتیاز هدیه دعوت دوستان</span>
            </div>
            <p class="small-text color-text mt-1">
              با دعوت از دوستان‌تان از طریق کد زیر، امتیاز باشگاه مشتریان را دریافت کنید.
            </p>
            <div>
              <div class="search-input">
                <span id="myTooltipTemp " style="display: block;width: 100%;text-align: center;background-color: red;font-weight: bold;border-radius: 5px;">{{ tooltipText }}</span>
                <input type="text" class="form-control rounded border color-text inviteLinkInput" style="direction: ltr" id="inviteLinkTemp" readonly="" :value="'https://radap.ir/Invite/' + auth.token" />
                <button class="btn btn-info w-100 mt-2" @click="copyLink">
                  کپی کردن
                </button>
              </div>
            </div>
            <div class="text-center py-2 m-auto">
              <p class="h3 mt-3">به اشتراک گذاری</p>
              <small class="d-block mb-3">کد معرفتان را از طریق لینک های زیر با دوستانتان به اشتراک بگذارید</small>
              <button class="btn btn-success w-100" @click="shareLink">
                اشتراک گذاری<i class="fa fa-share"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
<div class="text-danger" v-else>
شمامجوز دسترسی به این صفحه را ندارید
</div>
</template>

<script setup>
import { ref } from "vue";
import { useAuth } from '@/store/auth'
import { convertToPersian } from "@/composables/digits";
let auth = useAuth()
let level = ref();
let nextLevel = ref();
let nextScore = ref();
let inScore = ref();
let reagentCode = ref();
let tooltipText = ref();
setLevel();
function setLevel() {
  if (auth.profile.score < 1000) {
    level.value = "برنزی";
    nextLevel.value = "نقره ای";
    inScore.value = 1000;
    nextScore.value = inScore.value - auth.profile.score;
  } else if (1000 <= auth.profile.score && auth.profile.score < 10000) {
    level.value = "نقره ای";
    nextLevel.value = "طلایی";
    inScore.value = 10000;
    nextScore.value = inScore.value - auth.profile.score;
  } else if (10000 <= auth.profile.score && auth.profile.score < 50000) {
    level.value = "طلایی";
    nextLevel.value = "الماس";
    inScore.value = 50000;
    nextScore.value = inScore.value - auth.profile.score;
  } else if (50000 <= auth.profile.score) {
    level.value = "الماس";
    inScore.value = 1000000;
    nextScore.value = inScore.value - auth.profile.score;
  }
}
function copyLink() {
  var copyText = document.getElementById("inviteLinkTemp");
  copyText.select();
  copyText.setSelectionRange(0, 99999);
  document.execCommand("copy");
  tooltipText.value = "کپی  شد ...";
  setTimeout(() => {
    tooltipText.value = "";
  }, 600);
}
async function shareLink() {
  auth.getToken()
  reagentCode.value = 'https://radap.ir/Invite/'+auth.token
  const shareData = {
    title: "لینک معرفی",
    text: 'سلام، با راداَپ ضمن تهیه مایحتاج روزانت با قیمت مناسب و ارسال سریع، درآمد هم داشته باش،روی کد دعوت من بزن و با ثبت نام در راداَپ 10.000 تومان اعتبار هدیه بگیر، حس خوب خرید با راداَپ',
    url: reagentCode.value
  };
  try {
    await navigator.share(shareData);
  } catch (err) {
    console.log(err);
  }
}
</script>